import { render, staticRenderFns } from "./modal-confirm.vue?vue&type=template&id=ed965fda"
import script from "./modal-confirm.ts?vue&type=script&lang=js&external"
export * from "./modal-confirm.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports